import { template as template_8a55ed8c4b9f416ba43294cd7959a180 } from "@ember/template-compiler";
import Link from 'eflex/components/link';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import StandardModal from 'eflex/components/standard-modal';
import BsButton from 'eflex/components/bs-button';
import { fn } from '@ember/helper';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { t } from 'ember-intl';
import { formatDateWithoutTime } from 'eflex/helpers';
import config from 'eflex/config/environment';
import getProductVersion from 'eflex/util/get-product-version';
import moment from 'moment-timezone';
const NavLinkCard = template_8a55ed8c4b9f416ba43294cd7959a180(`
<div class="col-auto" ...attributes>
  <div class="d-flex align-items-start epicor-nav-link-card text-gray-600 border border-gray-300">
    <img src={{@iconSrc}} class="ms-n2" width="65" height="65" />
    <div class="d-flex flex-column py-2 pe-3">
      <div class="fw-semibold">{{@heading}}</div>
      <div class="mb-1">{{@body}}</div>
      {{#if @href}}
        <Link
          @href={{@href}}
          target="_blank"
          rel="noopener noreferrer"
          class="text-end text-decoration-none mb-1"
        >
          {{@linkLabel}}
        </Link>
      {{else if @linkAction}}
        <BsButton
          @type="link"
          class="text-end text-decoration-none mb-1"
          @onClick={{@linkAction}}
        >
          {{@linkLabel}}
        </BsButton>
      {{/if}}
    </div>
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const DataRow = template_8a55ed8c4b9f416ba43294cd7959a180(`
<div class="about-data-row d-flex justify-content-between fs-4" ...attributes>
  <span class="label fw-semibold text-gray-600">{{@label}}</span>
  <span class="value fw-semibold">{{@value}}</span>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const year = moment().get('year');
export default class NavBarHelp extends Component {
    @service
    router;
    @service
    licensing;
    @service
    currentUser;
    @service
    notifier;
    @service
    intl;
    @tracked
    aboutModalShown = false;
    @tracked
    copied = false;
    copyJson = async ()=>{
        try {
            await navigator.clipboard.writeText(JSON.stringify(this.payload, null, 2));
            this.copied = true;
            setTimeout(()=>(this.copied = false), 4000);
        } catch  {
            this.notifier.sendError(this.intl.t('copy.failed'));
        }
    };
    closeAboutModal = ()=>{
        this.aboutModalShown = false;
        if (this.copied) {
            this.copied = false;
        }
    };
    navigateToLicense = ()=>{
        this.closeAboutModal();
        this.router.transitionTo('settings.licensing');
    };
    get payload() {
        const lic = this.licensing.license;
        const license = lic ? {
            organization: lic.organization.name,
            license: lic.label,
            licenseId: lic.licenseId,
            stationLimit: lic.stationLimit,
            expiration: formatDateWithoutTime(lic.expirationDate, 'YYYY-MM-DD'),
            features: Array.from(new Set((Array.isArray(lic.features) ? lic.features : []).filter((f)=>f?.enabled === true).map((f)=>f?.key).filter(Boolean)))
        } : null;
        return {
            timestamp: new Date().toISOString(),
            app: {
                version: getProductVersion(),
                devVersion: config.APP.version
            },
            user: {
                user: this.currentUser.user?.userName ?? null,
                role: this.currentUser.user?.role ?? null,
                browser: navigator.userAgent,
                platform: navigator.userAgentData?.platform ?? null,
                locale: navigator.language,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            currentRoute: {
                name: this.router.currentRouteName,
                params: this.router.currentRoute?.params ?? {},
                query: this.router.currentRoute?.queryParams ?? {}
            },
            license
        };
    }
    static{
        template_8a55ed8c4b9f416ba43294cd7959a180(`
    <div class="nav-bar-help bg-white d-flex flex-column border-end border-gray-200 vh-100">
      <div class="bg-white px-3 pt-3">
        <div class="d-flex align-items-start justify-content-center">
          <img src="/images/epicor-logo-blue.png" width="100" class="menu-logo py-2" />
        </div>
      </div>

      <div class="row flex-column flex-nowrap eflex-scroll gy-3 gx-0 p-3 mt-auto">
        <NavLinkCard
          @heading={{t "epicor.learningCenter"}}
          @body={{t "epicor.learningCenter.desc"}}
          @href="https://erpcustomer.epicor.com/lms/home"
          @linkLabel={{t "access.blank" item=(t "epicor.learningCenter")}}
          @iconSrc="/images/icons/learning-center.svg"
        />

        <NavLinkCard
          @heading="EpicCare"
          @body={{t "epicor.epicCare.desc"}}
          @href="https://epiccare.epicor.com/epiccare"
          @linkLabel={{t "access.blank" item="EpicCare"}}
          @iconSrc="/images/icons/epic-care.svg"
        />

        <NavLinkCard
          @heading="EpicWeb"
          @body={{t "epicor.epicWeb.desc"}}
          @href="https://epicweb.epicor.com/products/connected-process-control/documentation"
          @linkLabel={{t "access.blank" item="EpicWeb"}}
          @iconSrc="/images/icons/epic-web.svg"
        />

        <NavLinkCard
          @heading={{t "epicor.epicorIdeas"}}
          @body={{t "epicor.epicorIdeas.desc"}}
          @href="https://epicor.ideas.aha.io/?project=CPC"
          @linkLabel={{t "access.blank" item=(t "epicor.epicorIdeas")}}
          @iconSrc="/images/icons/ideas.svg"
        />

        <NavLinkCard
          class="about"
          @heading={{t "about"}}
          @body={{t "epicor.about.desc"}}
          @linkAction={{fn (mut this.aboutModalShown) true}}
          @linkLabel={{t "about"}}
          @iconSrc="/images/icons/about-information.svg"
        />
      </div>
    </div>

    {{#if this.aboutModalShown}}
      <StandardModal
        class="about-modal"
        @size="sm"
        @onCancel={{this.closeAboutModal}}
      as |modal|>
        <modal.header @text={{t "about"}} />
        <modal.body>
          <div class="mb-4">
            <p class="fw-bold mb-2">{{t "about.systemSummary"}}</p>
            <DataRow class="version" @label={{t "version"}} @value={{getProductVersion}} />
            <DataRow class="devVersion" @label={{t "developmentVersion"}} @value={{config.APP.version}} />
          </div>

          {{#let this.licensing.license as |license|}}
            <div class="mb-5">
              <div class="d-flex align-items-center mb-2">
                <p class="fw-bold mb-0">{{t "settings.licensemgt"}}</p>
                <BsButton
                  @type="peripheral"
                  @onClick={{this.navigateToLicense}}
                  class="ms-2"
                >
                  <FaIcon @icon="arrow-up-right-from-square" />
                </BsButton>
              </div>
              {{#if this.licensing.unlicensed}}
                <div class="fw-semibold text-danger">
                  <FaIcon @icon="circle-exclamation" @prefix="fas" class="me-2 text-danger" />
                  {{t "settings.licensing.unlicensed"}}
                </div>
              {{else}}
                <DataRow class="organization" @label={{t "organization"}} @value={{license.organization.name}} />
                <DataRow class="license" @label={{t "license"}} @value={{license.label}} />
                <DataRow class="licenseNo" @label={{t "settings.license.licenseNumber"}} @value={{license.licenseId}} />
                <DataRow
                  class="stationLimit"
                  @label={{t "licensing.concurrentStationLimit"}}
                  @value={{license.stationLimit}}
                />
                <DataRow
                  class="expirationDate"
                  @label={{t "settings.licensing.expirationDate"}}
                  @value={{formatDateWithoutTime license.expirationDate "YYYY-MM-DD"}}
                />
              {{/if}}
            </div>
          {{/let}}

          <div class="d-flex justify-content-center">
            <BsButton
              class="copy-to-clipboard"
              @size="sm"
              @onClick={{this.copyJson}}
            >
              <FaIcon @prefix="fas" @icon={{if this.copied "check" "copy"}} class="fa-fw me-1" />
              <span>{{if this.copied (t "copy.copied") (t "copy.clipboard") }}</span>
            </BsButton>
          </div>
        </modal.body>
        <modal.footer class="align-items-center">
          <span class="fs-4 fw-semibold text-gray-600 mx-auto">{{t "footer"}} © {{year}}.</span>
        </modal.footer>
      </StandardModal>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
